export const formatLabel = (value) => {
  if (!value) return "";
  return value
    .toString()
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const getOrderStatusStyles = (status = "") => {
  const s = status.toString().toLowerCase();

  if (s.includes("cancel") || s.includes("fail") || s.includes("reject")) {
    return { bg: "bg-red-50", text: "text-red-700", ring: "ring-red-600/20", dot: "bg-red-500" };
  }
  if (s.includes("refund")) {
    return { bg: "bg-orange-50", text: "text-orange-700", ring: "ring-orange-600/20", dot: "bg-orange-500" };
  }
  if (s.includes("pending")) {
    return { bg: "bg-amber-50", text: "text-amber-700", ring: "ring-amber-600/20", dot: "bg-amber-500" };
  }
  if (s.includes("process") || s.includes("progress")) {
    return { bg: "bg-blue-50", text: "text-blue-700", ring: "ring-blue-600/20", dot: "bg-blue-500" };
  }
  if (s.includes("confirm")) {
    return { bg: "bg-teal-50", text: "text-teal-700", ring: "ring-teal-600/20", dot: "bg-teal-500" };
  }
  if (s.includes("ship") || s.includes("transit") || s.includes("dispatch")) {
    return { bg: "bg-indigo-50", text: "text-indigo-700", ring: "ring-indigo-600/20", dot: "bg-indigo-500" };
  }
  if (s.includes("deliver") || s.includes("complete") || s.includes("success")) {
    return { bg: "bg-green-50", text: "text-green-700", ring: "ring-green-600/20", dot: "bg-green-500" };
  }

  return { bg: "bg-gray-50", text: "text-gray-700", ring: "ring-gray-600/20", dot: "bg-gray-400" };
};

export const ORDER_STATUS_OPTIONS = [
  { value: "", label: "All Statuses" },
  { value: "pending_payment", label: "Pending Payment" },
  { value: "processing", label: "Processing" },
  { value: "confirmed", label: "Confirmed" },
  { value: "shipped", label: "Shipped" },
  { value: "delivered", label: "Delivered" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "refunded", label: "Refunded" },
];

export const FULFILLMENT_TYPE_OPTIONS = [
  { value: "", label: "All Fulfillment" },
  { value: "delivery", label: "Delivery" },
  { value: "pickup", label: "Pickup" },
];

export const PURCHASE_TYPE_OPTIONS = [
  { value: "", label: "All Purchase Types" },
  { value: "cart_checkout", label: "Cart Checkout" },
  { value: "buy_now", label: "Buy Now" },
];

export const PAYMENT_STATUS_FILTER_OPTIONS = [
  { value: "", label: "All Payment Statuses" },
  { value: "initiated", label: "Initiated" },
  { value: "completed", label: "Completed" },
  { value: "failed", label: "Failed" },
  { value: "pending", label: "Pending" },
];

export const SORT_ORDER_OPTIONS = [
  { value: "desc", label: "Newest First" },
  { value: "asc", label: "Oldest First" },
];

export const PAGE_SIZE_OPTIONS = [10, 15, 25, 50];

export const ORDER_STATUS_UPDATE_OPTIONS = ORDER_STATUS_OPTIONS.filter((opt) => opt.value);

export const getStatusOptionsWithCurrent = (currentStatus) => {
  if (!currentStatus) return ORDER_STATUS_UPDATE_OPTIONS;
  const exists = ORDER_STATUS_UPDATE_OPTIONS.some((opt) => opt.value === currentStatus);
  if (exists) return ORDER_STATUS_UPDATE_OPTIONS;
  return [{ value: currentStatus, label: formatLabel(currentStatus) }, ...ORDER_STATUS_UPDATE_OPTIONS];
};
